import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminosdelivery',
  templateUrl: './terminosdelivery.component.html',
  styleUrls: ['./terminosdelivery.component.css']
})
export class TerminosdeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
